import { company } from '../data/company';

export interface OrderEnquiry {
  commodity: string;
  quantity: string;
  destination: string;
  incoterm: string;
  name: string;
  organisation: string;
  email: string;
  phone: string;
  message: string;
}

const emptyLine = (label: string, value: string) => `${label}: ${value || '—'}`;

export function buildOrderEmail(enquiry: OrderEnquiry): string {
  const subject = `Purchase enquiry — ${enquiry.commodity || 'Minerals'}${
    enquiry.quantity ? ` (${enquiry.quantity})` : ''
  }`;

  const body = [
    `Dear ${company.shortName} trading desk,`,
    '',
    'I would like to place an order enquiry with the following details:',
    '',
    emptyLine('Commodity', enquiry.commodity),
    emptyLine('Quantity required', enquiry.quantity),
    emptyLine('Delivery destination / port', enquiry.destination),
    emptyLine('Preferred incoterm', enquiry.incoterm),
    '',
    emptyLine('Contact name', enquiry.name),
    emptyLine('Company', enquiry.organisation),
    emptyLine('Email', enquiry.email),
    emptyLine('Phone / WhatsApp', enquiry.phone),
    '',
    'Additional requirements:',
    enquiry.message || '—',
    '',
    'Kind regards,',
    enquiry.name || '',
  ].join('\n');

  return `mailto:${company.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function quickOrderMailto(commodity?: string): string {
  const subject = commodity
    ? `Order enquiry — ${commodity}`
    : `Order enquiry — ${company.shortName}`;
  const body = [
    `Dear ${company.shortName} trading desk,`,
    '',
    `I would like to place an order${commodity ? ` for ${commodity}` : ''}. Please send your current offer, specification sheet and payment terms.`,
    '',
    'Quantity required:',
    'Delivery destination:',
    'Preferred incoterm:',
    'Company name:',
    'Contact number:',
    '',
    'Kind regards,',
  ].join('\n');
  return `mailto:${company.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function whatsappLink(message?: string): string {
  const text =
    message ??
    `Hello ${company.shortName}, I would like to enquire about placing a minerals order.`;
  return `https://wa.me/${company.whatsappDigits}?text=${encodeURIComponent(text)}`;
}
